module.exports = __webpack_public_path__ + "img/win_paytable.c531974b.png";